/* eslint-disable react/no-unescaped-entities */
/* eslint-disable react/no-unknown-property */
/* eslint-disable no-useless-escape */
/* eslint-disable react/prop-types */
import React, { Component } from "react";
import { useNavigate, useParams } from "react-router-dom";
import Header from "../Components/Header";
import SubHeader from "../Components/SubHeader";
import Loader from "../Components/Loader";
import Footer from "../Components/Footer";
import Cookies from "js-cookie";

import "../Styles/ofislerimiz.css";

function withRouter(Component) {
  function ComponentWithRouterProp(props) {
    let navigate = useNavigate();
    let params = useParams();
    return <Component {...props} router={{ navigate, params }} />;
  }

  return ComponentWithRouterProp;
}

class MembershipAgreement extends Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: true,
      isCollapsed: false,
      isMenuOpen: false,
      isMobile: window.innerWidth <= 768,
      belge: null, // panelden yayınlanan sürüm (metni varsa sabit metnin yerine gösterilir)
      ucretMetni: null, // "350 TL" — yönetim panelindeki güncel üyelik ücreti
      // Panelden yeni sürüm yayınlanınca sabit 2.1 metni gizlenir; yenileyene kadar 2.1'e tabi üye için açılabilir
      oncekiSurumAcik: false,
    };
  }

  // Sabit metindeki abonelik bedeli panelden gelir; alınamazsa tutar yerine ödeme adımına atıf yapılır
  ucretGetir = async () => {
    try {
      const response = await fetch(`${process.env.REACT_APP_API_URL}/api/posnet/uyelik-ucreti`);
      const result = await response.json();
      if (result.success && Number(result.tl) > 0) {
        this.setState({ ucretMetni: `${Number(result.tl).toLocaleString("tr-TR")} TL` });
      }
    } catch (error) {
      console.error("Üyelik ücreti alınamadı:", error);
    }
  };

  abonelikBedeli = () => this.state.ucretMetni || "ödeme adımında gösterilen tutar";

  componentDidMount() {
    setTimeout(() => {
      this.setState({ loading: false });
    }, 500);
    window.addEventListener("scroll", this.handleScroll);
    window.addEventListener("resize", this.handleResize);
    this.handleScroll();
    this.yayindakiSurumuGetir();
    this.ucretGetir();
  }

  // Yayındaki sürümün metni ut-admin'den girildiyse sayfadaki sabit metin yerine o gösterilir
  yayindakiSurumuGetir = async () => {
    try {
      const response = await fetch(
        `${process.env.REACT_APP_API_URL}/api/belgeler/yayinda/uyelik_sozlesmesi`
      );
      const result = await response.json();
      if (result.m === "basarili") this.setState({ belge: result.belge });
    } catch (error) {
      console.error("Sözleşme sürümü alınamadı:", error);
    }
  };

  componentWillUnmount() {
    window.removeEventListener("scroll", this.handleScroll);
    window.removeEventListener("resize", this.handleResize);
  }

  handleResize = () => {
    this.setState({ isMobile: window.innerWidth <= 768 });
  };

  handleScroll = () => {
    const scrollTop = window.pageYOffset;
    const isCollapsed = scrollTop > 60;
    this.setState({ isCollapsed });
  };

  goBackToPolicies = () => {
    this.props.router.navigate("/gizlilik_politikasi");
  };

  render() {
    return (
      <>
        <Loader />
        <SubHeader />
        <Header isLoggedIn={Cookies.get("token") == null ? false : true} />

        <div className="offices-header">
          <div className="offices-header-pattern" />

          <div className="container offices-header-container">
            <div className="row">
              <div className="text-center">
                <h1 className="offices-header-title">
                  NM Universal Team
                  <br />
                  Üyelik Sözleşmesi
                </h1>
              </div>
            </div>
          </div>
        </div>

        <div className="ex-basic-2">
          <div className="container">
            <div className="row mt-5 mb-5">
              <div className="col-lg-12">
                <div className="metin-kutusu">
                  <div style={{ marginBottom: "20px" }}>
                    <button
                      onClick={this.goBackToPolicies}
                      style={{
                        backgroundColor: "#6c757d",
                        color: "white",
                        border: "none",
                        padding: "8px 16px",
                        borderRadius: "5px",
                        cursor: "pointer",
                        fontSize: "14px",
                        display: "flex",
                        alignItems: "center",
                        gap: "5px",
                      }}
                    >
                      ← Politikalar Sayfasına Dön
                    </button>
                  </div>

                  {this.state.belge && this.state.belge.metin && (
                    <div style={{ lineHeight: "1.6", fontSize: "15px" }}>
                      <div style={{ textAlign: "center", marginBottom: "30px" }}>
                        <h1>{this.state.belge.baslik}</h1>
                        <p>
                          <strong>
                            Sürüm {this.state.belge.surum} · Yürürlük: {this.state.belge.yururlukMetin}
                          </strong>
                        </p>
                      </div>
                      <div style={{ whiteSpace: "pre-wrap" }}>{this.state.belge.metin}</div>
                      <div
                        style={{
                          marginTop: "40px",
                          padding: "16px",
                          border: "1px solid #dee2e6",
                          borderRadius: "8px",
                          backgroundColor: "#f8f9fa",
                        }}
                      >
                        <p style={{ marginBottom: "10px" }}>
                          Bu sözleşme yayınlanmadan önce üye olduysanız, güncel sürümü onaylayana kadar (uygulamada
                          çıkan pencereden ya da üyeliğinizi yenilerken) önceki sürüm (2.1) geçerlidir.
                        </p>
                        <button
                          onClick={() => this.setState((s) => ({ oncekiSurumAcik: !s.oncekiSurumAcik }))}
                          style={{
                            backgroundColor: "#6c757d",
                            color: "white",
                            border: "none",
                            padding: "8px 16px",
                            borderRadius: "5px",
                            cursor: "pointer",
                            fontSize: "14px",
                          }}
                        >
                          {this.state.oncekiSurumAcik ? "Önceki sürümü gizle" : "Önceki sürümü göster (2.1 · 28 Nisan 2026)"}
                        </button>
                      </div>
                    </div>
                  )}
                  <div
                    style={{
                      lineHeight: "1.6",
                      fontSize: "15px",
                      marginTop: this.state.belge && this.state.belge.metin ? "40px" : undefined,
                      display:
                        this.state.belge && this.state.belge.metin && !this.state.oncekiSurumAcik ? "none" : undefined,
                    }}
                  >
                    <div style={{ textAlign: "center", marginBottom: "30px" }}>
                      <h1>NM UNIVERSAL TEAM ÜYELİK VE SATIŞ SÖZLEŞMESİ</h1>
                      <p><strong>Son Güncelleme: 28 Nisan 2026</strong></p>
                    </div>

                    <h2>TARAFLAR</h2>
                    <p><strong>Hizmet Sağlayıcı:</strong></p>
                    <p>Adil Onur Karahan Şahıs Şirketi</p>
                    <p><strong>E-posta:</strong> yazilimkodjet@gmail.com
</p>
                    <p><strong>Üye:</strong> Platform'a kayıt olan gerçek kişi</p>

                    <h2>MADDE 1 - TANIMLAR</h2>
                    <p>Bu sözleşmede geçen terimler aşağıdaki anlamları ifade eder:</p>
                    <ul>
                      <li><strong>Platform:</strong> NM Universal Team mobil uygulaması ve web sitesi</li>
                      <li><strong>Üye/Kullanıcı:</strong> Platform'a kayıt olan 18 yaşını doldurmuş gerçek kişi</li>
                      <li><strong>Hizmet Sağlayıcı:</strong> Adil Onur Karahan Şahıs Şirketi</li>
                      <li><strong>Abonelik:</strong> Platform hizmetlerinden yararlanma hakkı veren yıllık üyelik</li>
                      <li><strong>Dijital Hizmet:</strong> Platform üzerinden sunulan tüm yazılım ve içerik hizmetleri</li>
                      <li><strong>Hediye Kodu:</strong> Platform aboneliği satın almak için kullanılabilen dijital kod</li>
                      <li><strong>KVKK:</strong> 6698 sayılı Kişisel Verilerin Korunması Kanunu</li>
                      <li><strong>TKHK:</strong> 6502 sayılı Tüketicinin Korunması Hakkında Kanun</li>
                      <li><strong>ETK:</strong> 6563 sayılı Elektronik Ticaret Kanunu</li>
                    </ul>

                    <h2>MADDE 2 - SÖZLEŞMENİN KONUSU VE KAPSAMI</h2>
                    <p><strong>2.1.</strong> Bu sözleşme, NM Universal Team mobil uygulaması ve web sitesi üzerinden sunulan ekip yönetim sistemi hizmetlerinin kullanım şart ve koşullarını düzenler.</p>
                    <p><strong>2.2.</strong> Platform Kapsamında Sunulan Hizmetler:</p>
                    <ul>
                      <li>Görev atama ve takip sistemi</li>
                      <li>Rapor ve analiz araçları</li>
                      <li>Eğitim modülleri ve video içerikleri</li>
                      <li>Takvim ve planlama araçları</li>
                      <li>Ekip iletişim ve işbirliği araçları</li>
                      <li>Diğer ekip yönetim özellikleri</li>
                    </ul>
                    <p><strong>2.3.</strong> Hizmetler dijital ortamda, kesintisiz erişim hedeflenerek sunulur.</p>
                    <p><strong>2.4.</strong> Platform özellikleri zaman içinde geliştirilebilir, değiştirilebilir veya kaldırılabilir.</p>
                    <p><strong>2.5.</strong> Yaş Sınırı:</p>
                    <ul>
                      <li>Platform'a üye olabilmek için en az 18 yaşında olmak gerekmektedir</li>
                      <li>18 yaşından küçük kişilerin üyelik işlemleri yasal vasi onayı ile gerçekleştirilmelidir</li>
                      <li>Yaş beyanında bulunmak üyenin sorumluluğundadır</li>
                    </ul>

                    <h2>MADDE 3 - ABONELİK VE ÖDEME ŞARTLARI</h2>
                    <p><strong>3.1.</strong> Abonelik Modeli: Platform hizmetleri yıllık abonelik modeli ile sunulmaktadır.</p>
                    <p><strong>3.2.</strong> Abonelik Bedeli: Yıllık abonelik bedeli: <strong>{this.abonelikBedeli()} (KDV Dahil)</strong></p>
                    <p><strong>3.3.</strong> Ödeme Zamanı: Abonelik bedeli, üyelik başlangıcında peşin olarak tahsil edilir.</p>
                    <p><strong>3.4.</strong> Ödeme Yöntemleri:</p>
                    <ul>
                      <li>Kredi kartı</li>
                      <li>Banka kartı</li>
                      <li>Diğer elektronik ödeme yöntemleri</li>
                      <li>Hediye kodu kullanımı</li>
                      <li>Tüm ödemeler web sitesi üzerinden sanal POS ile alınır</li>
                    </ul>
                    <p><strong>3.5.</strong> KDV ve Faturalama:</p>
                    <p><strong>3.5.1.</strong> KDV Uygulaması:</p>
                    <ul>
                      <li>Tüm fiyatlar KDV dahil olarak gösterilir</li>
                      <li>Geçerli KDV oranı: %20 (mevzuat değişikliklerine tabidir)</li>
                      <li>KDV değişikliğinde yeni oran uygulanır</li>
                    </ul>
                    <p><strong>3.5.2.</strong> Fatura Düzenleme:</p>
                    <ul>
                      <li>Kurumsal fatura talebi için yazilimkodjet@gmail.com
 adresine başvurulmalıdır</li>
                      <li>Fatura bilgilerinde hata olması durumunda 7 gün içinde düzeltme talep edilebilir</li>
                      <li><strong>Fatura Düzenlenmesi ve İletimi:</strong> İşbu sözleşmeyi kabul ederek, 433 Sıra No'lu Vergi Usul Kanunu Genel Tebliği uyarınca tarafınıza düzenlenecek e-Arşiv faturaların e-posta, SMS veya doğrudan Müşteri Paneli / Faturalarım sekmesi üzerinden elektronik ortamda tarafınıza sunulmasını kabul etmiş olursunuz. Müşteri, dilediği zaman paneli üzerinden faturalarını PDF formatında görüntüleyebilir ve indirebilir.</li>
                    </ul>
                    <p><strong>3.5.3.</strong> Vergi Mükellefiyeti:</p>
                    <ul>
                      <li>Hizmet Sağlayıcı tüm vergi yükümlülüklerini yerine getirir</li>
                      <li>Gerekli tüm yasal kayıtlar tutulur</li>
                    </ul>
                    <p><strong>3.6.</strong> Abonelik Süresi: Abonelik süresi, ödeme onayı alındığı tarihten itibaren 365 gündür.</p>
                    <p><strong>3.7.</strong> Otomatik Yenileme:</p>
                    <ul>
                      <li>Platform'da otomatik yenileme sistemi BULUNMAMAKTADIR</li>
                      <li>Abonelik süresi sonunda hizmet otomatik olarak sona erer</li>
                      <li>Yenileme yapmak isteyen üye manuel olarak ödeme yapmalıdır</li>
                    </ul>

                    <h2>MADDE 4 - HEDİYE KODU SİSTEMİ</h2>
                    <p><strong>4.1.</strong> Hediye Kodu Özellikleri:</p>
                    <ul>
                      <li>Hediye kodları platform aboneliği satın almak için kullanılır</li>
                      <li>Her kod tek kullanımlıktır ve benzersizdir</li>
                      <li>Kodlar üçüncü kişilere devredilebilir</li>
                      <li>Sistem tarafından güvenli şekilde üretilir</li>
                    </ul>
                    <p><strong>4.2.</strong> Kullanım Şartları:</p>
                    <ul>
                      <li>Hediye kodu geçerlilik süresi: Satın alma tarihinden itibaren 12 ay</li>
                      <li>Süre dolmuş kodlar kullanılamaz</li>
                      <li>Kod kullanıldıktan sonra 365 günlük abonelik süresi başlar</li>
                      <li>Her kod sadece bir kez kullanılabilir</li>
                    </ul>
                    <p><strong>4.3.</strong> Satış ve İade Politikası:</p>
                    <ul>
                      <li>Hediye kodlarından hiçbir şekilde iade yapılmaz</li>
                      <li>Kullanılmamış kodlar için de iade yapılmaz</li>
                      <li>Kod başkasına devredilebilir ancak satış bedeli iade edilmez</li>
                      <li>Hizmet Sağlayıcı kusuru durumunda iade yapılabilir</li>
                    </ul>
                    <p><strong>4.4.</strong> Teknik Sorunlar:</p>
                    <ul>
                      <li>Kod aktivasyon sorunlarında teknik destek yazilimkodjet@gmail.com adresinden sağlanır</li>
                      <li>Sistemsel hata durumunda yeni kod üretilebilir veya ödeme iadesi yapılabilir</li>
                    </ul>
                    <p><strong>4.5.</strong> Hediye Kodu Kullanımı:</p>
                    <ul>
                      <li>Kodlar Platform kayıt veya abonelik yenileme ekranından girilir</li>
                      <li>Geçerli kod girildikten sonra hesap aktif hale gelir</li>
                      <li>Kod kullanım tarihi ve saati sistem tarafından kaydedilir</li>
                    </ul>

                    <h2>MADDE 5 - HİZMET SUNUMU VE ABONELİK YÖNETİMİ</h2>
                    <p><strong>5.1.</strong> Hizmet Başlangıcı:</p>
                    <ul>
                      <li>Dijital hizmet sunumu, ödeme onayının alınmasını takiben derhal başlar</li>
                      <li>Üye, ödeme işlemi ile birlikte Platform'daki tüm özelliklere anında erişim hakkı kazanır</li>
                      <li>TKHK md.16/m uyarınca cayma hakkı kullanılamaz (dijital içerik derhal sunulduğundan)</li>
                    </ul>
                    <p><strong>5.2.</strong> Hizmet Sürekliliği:</p>
                    <ul>
                      <li>Hizmet sunumu kesintisiz sağlanmaya çalışılır</li>
                      <li>Teknik sorunlar, bakım çalışmaları, internet altyapı sorunları veya mücbir sebepler nedeniyle kesintiler yaşanabilir</li>
                      <li>Planlı bakımlar mümkün olduğunca önceden duyurulur</li>
                    </ul>
                    <p><strong>5.3.</strong> Kullanıcı Tarafından Hesap Kapatma:</p>
                    <ul>
                      <li>Kullanıcı istediği zaman hesabını kapatabilir</li>
                      <li>Hesap kapatma talebi yazilimkodjet@gmail.com adresine e-posta ile yapılır</li>
                      <li>Talep 7 iş günü içinde değerlendirilir</li>
                    </ul>
                    <p><strong>5.4.</strong> İade Koşulları:</p>
                    <p><strong>5.4.1.</strong> Kullanıcı İsteğiyle İptal:</p>
                    <ul>
                      <li>Kullanıcı kendi isteğiyle hesap kapatırsa ve hizmeti kullanmışsa iade yapılmaz</li>
                      <li>ANCAK: Aşağıdaki durumlarda iade yükümlülüğü doğar:</li>
                      <li style={{ marginLeft: "20px" }}>- Ayıplı hizmet sunumu</li>
                      <li style={{ marginLeft: "20px" }}>- Hizmetin hiç ifa edilmemesi</li>
                      <li style={{ marginLeft: "20px" }}>- Hizmet Sağlayıcı kusurlu ise</li>
                      <li style={{ marginLeft: "20px" }}>- Sözleşme ihlali varsa</li>
                    </ul>
                    <p><strong>5.4.2.</strong> Hizmet Sağlayıcı Tarafından Hesap Kapatma:</p>
                    <ul>
                      <li>Hizmet Sağlayıcı, gerekli gördüğü durumlarda (Madde 8.2'de belirtilen) hesabı kapatabilir</li>
                      <li>Bu durumda kullanılmayan gün sayısı oranında iade yapılır</li>
                      <li>İade hesaplama formülü: (Kalan gün sayısı / 365) × Ödenen tutar</li>
                    </ul>
                    <p><strong>5.4.3.</strong> İade İşlem Süresi:</p>
                    <ul>
                      <li>Hizmet Sağlayıcı kaynaklı iadeler 10 iş günü içinde yapılır</li>
                      <li>İadeler ödeme yapılan karta/hesaba geri gönderilir</li>
                      <li>İade süreci e-posta ile bildirilir</li>
                    </ul>
                    <p><strong>5.5.</strong> Abonelik Sona Erme:</p>
                    <ul>
                      <li>Abonelik süresi 365 gün sonra otomatik olarak sona erer</li>
                      <li>Abonelik bitiş tarihinden 30 gün önce üyeye e-posta ile bildirim yapılır</li>
                      <li>Yenileme yapmak isteyen üye manuel olarak ödeme yapmalıdır</li>
                      <li>Sözleşme feshi için ayrı bildirim gerekmez</li>
                      <li>Süre sonunda hesap pasif duruma geçer, veriler KVKK uyarınca saklanır</li>
                    </ul>

                    <h2>MADDE 6 - ÜYE YÜKÜMLÜLÜKLERI</h2>
                    <p><strong>6.1.</strong> Genel Yükümlülükler:</p>
                    <ul>
                      <li>Üye, Platform'ı Türkiye Cumhuriyeti kanunlarına ve genel ahlaka uygun şekilde kullanacağını taahhüt eder</li>
                      <li>Kayıt sırasında doğru ve güncel bilgi vermelidir</li>
                      <li>Yaş beyanının doğruluğundan sorumludur</li>
                    </ul>
                    <p><strong>6.2.</strong> Hesap Güvenliği:</p>
                    <ul>
                      <li>Üye, hesap bilgilerinin (kullanıcı adı, şifre) güvenliğinden tamamen sorumludur</li>
                      <li>Şifresini başkalarıyla paylaşmamalıdır</li>
                      <li>Yetkisiz erişim şüphesi durumunda derhal Hizmet Sağlayıcı'yı bilgilendirmelidir</li>
                      <li>Hesap güvenliği ihlalinden doğan zararlar üyenin sorumluluğundadır</li>
                    </ul>
                    <p><strong>6.3.</strong> Yasak Faaliyetler:</p>
                    <p>Üye aşağıdaki eylemleri yapmayacağını kabul eder:</p>
                    <ul>
                      <li>Sahte, yanıltıcı veya zarar verici içerik paylaşmak</li>
                      <li>Diğer kullanıcıları taciz etmek veya rahatsız etmek</li>
                      <li>Telif hakkı, fikri mülkiyet haklarını ihlal etmek</li>
                      <li>Sisteme zarar verecek yazılım, virüs veya zararlı kod yüklemek</li>
                      <li>Platform'u otomatik araçlarla taramak veya veri çekmek</li>
                      <li>Platform güvenliğini test etmek veya zaafiyetlerini aramak</li>
                      <li>Spam veya toplu istenmeyen mesaj göndermek</li>
                      <li>Başkasının hesabını yetkisiz kullanmak</li>
                    </ul>
                    <p><strong>6.4.</strong> İçerik Sorumluluğu:</p>
                    <ul>
                      <li>Üye, Platform'a yüklediği tüm içeriklerden sorumludur</li>
                      <li>Yüklenen içeriklerin yasal haklara sahip olunduğundan emin olunmalıdır</li>
                      <li>Hukuka aykırı içerik yüklenemez</li>
                    </ul>
                    <p><strong>6.5.</strong> İletişim Bilgileri:</p>
                    <ul>
                      <li>Üye, iletişim bilgilerini güncel tutmalıdır</li>
                      <li>E-posta adresinde değişiklik olursa sistem üzerinden güncellenmelidir</li>
                      <li>Hizmet Sağlayıcı bildirimleri kayıtlı e-posta adresine gönderir</li>
                    </ul>

                    <h2>MADDE 7 - HİZMET SAĞLAYICI YÜKÜMLÜLÜKLERI</h2>
                    <p><strong>7.1.</strong> Hizmet Kalitesi:</p>
                    <ul>
                      <li>Hizmet Sağlayıcı, Platform hizmetlerini sürekli ve kaliteli sunmaya özen gösterir</li>
                      <li>Sistem performansını ve güvenliğini korumak için gerekli tedbirleri alır</li>
                      <li>Düzenli bakım ve güncellemeler yapar</li>
                    </ul>
                    <p><strong>7.2.</strong> Veri Güvenliği:</p>
                    <ul>
                      <li>Kişisel verilerin KVKK'ya uygun işlenmesi ve korunması sağlanır</li>
                      <li>Güvenli sunucu ve şifreleme teknolojileri kullanılır</li>
                      <li>Düzenli güvenlik testleri ve güncellemeleri yapılır</li>
                      <li>Veri ihlali durumunda KVKK uyarınca gerekli bildirimler yapılır</li>
                    </ul>
                    <p><strong>7.3.</strong> Teknik Destek:</p>
                    <ul>
                      <li>Teknik destek hizmetleri yazilimkodjet@gmail.com adresinden sağlanır</li>
                      <li>Destek talepleri 48 saat içinde yanıtlanmaya çalışılır</li>
                      <li>Acil teknik sorunlar öncelikli olarak ele alınır</li>
                    </ul>
                    <p><strong>7.4.</strong> Bilgilendirme:</p>
                    <ul>
                      <li>Önemli sistem değişiklikleri önceden duyurulur</li>
                      <li>Sözleşme değişiklikleri Platform üzerinden yayınlanır</li>
                      <li>Abonelik süresi bitiminden 30 gün önce hatırlatma e-postası gönderilir</li>
                    </ul>
                    <p><strong>7.5.</strong> Gizlilik:</p>
                    <ul>
                      <li>Üye bilgileri üçüncü kişilerle yasal zorunluluklar dışında paylaşılmaz</li>
                      <li>Gizlilik Politikası'na ve KVKK'ya uygun hareket edilir</li>
                    </ul>

                    <h2>MADDE 8 - SÖZLEŞMENİN FESHİ</h2>
                    <p><strong>8.1.</strong> Doğal Sona Erme:</p>
                    <ul>
                      <li>Sözleşme, 365 günlük abonelik süresinin bitiminde kendiliğinden sona erer</li>
                      <li>Yenileme yapılmadığı takdirde hesap pasif hale gelir</li>
                      <li>Ayrı bir fesih bildirimine gerek yoktur</li>
                    </ul>
                    <p><strong>8.2.</strong> Hizmet Sağlayıcı Tarafından Fesih:</p>
                    <p>Hizmet Sağlayıcı aşağıdaki durumlarda sözleşmeyi derhal feshedebilir:</p>
                    <p><strong>8.2.1.</strong> Hukuka Aykırı Kullanım:</p>
                    <ul>
                      <li>Sahte bilgi veya kimlik kullanımı</li>
                      <li>Yanıltıcı, zarar verici içerik paylaşımı</li>
                      <li>Platform kurallarını ciddi şekilde ihlal etme</li>
                    </ul>
                    <p><strong>8.2.2.</strong> Ödeme Sorunları:</p>
                    <ul>
                      <li>Abonelik ücretinin ödenmemesi</li>
                      <li>Ödeme işlemlerinde sahtecilik tespiti</li>
                      <li>Kredi kartı iade talepleri (chargeback) kötüye kullanımı</li>
                    </ul>
                    <p><strong>8.2.3.</strong> Sisteme Zarar Verici Faaliyetler:</p>
                    <ul>
                      <li>Hack girişimi, siber saldırı</li>
                      <li>Virüs, zararlı yazılım yükleme</li>
                      <li>Sistem güvenliğini tehlikeye atma</li>
                    </ul>
                    <p><strong>8.2.4.</strong> Üçüncü Kişi Haklarının İhlali:</p>
                    <ul>
                      <li>Telif hakkı ihlali</li>
                      <li>Fikri mülkiyet hakkı ihlali</li>
                      <li>Patent veya marka ihlali</li>
                    </ul>
                    <p><strong>8.2.5.</strong> Platform'un Kötüye Kullanımı:</p>
                    <ul>
                      <li>Spam gönderimi</li>
                      <li>Taciz edici davranışlar</li>
                      <li>Toplu otomatik işlemler</li>
                    </ul>
                    <p><strong>8.3.</strong> Fesih Sonuçları:</p>
                    <ul>
                      <li>Hizmet Sağlayıcı kaynaklı fesihte: Kullanılmayan süre oranında iade yapılır</li>
                      <li>Üye kaynaklı kural ihlalinde fesihte: İade yapılmaz</li>
                      <li>Hesap 7 gün içinde kalıcı olarak kapatılır</li>
                      <li>Kullanıcı verileri KVKK uyarınca işlenir</li>
                    </ul>
                    <p><strong>8.4.</strong> Kullanıcı Tarafından Fesih:</p>
                    <ul>
                      <li>Kullanıcı istediği zaman hesabını kapatma talebinde bulunabilir</li>
                      <li>Talep yazilimkodjet@gmail.com adresine gönderilir</li>
                      <li>7 iş günü içinde hesap kapatılır</li>
                      <li>İade koşulları Madde 5.4'e tabidir</li>
                    </ul>

                    <h2>MADDE 9 - FİKRİ MÜLKİYET VE İÇERİK POLİTİKASI</h2>
                    <p><strong>9.1.</strong> Platform Hakları:</p>
                    <p><strong>9.1.1.</strong> Fikri Mülkiyet:</p>
                    <ul>
                      <li>Platform'da yer alan tüm yazılım, tasarım, logo, marka ve sistem Hizmet Sağlayıcı'ya aittir</li>
                      <li>Platform kaynak kodları, veritabanı yapısı ve algoritmaları korunmaktadır</li>
                      <li>Üye, Platform'ı kopyalama, çoğaltma, dağıtma veya tersine mühendislik hakkına sahip değildir</li>
                    </ul>
                    <p><strong>9.1.2.</strong> Kullanım Lisansı:</p>
                    <ul>
                      <li>Üye, sadece kişisel kullanım için sınırlı, devredilemez lisans alır</li>
                      <li>Ticari amaçla kullanamaz</li>
                      <li>Alt lisans veremez</li>
                    </ul>
                    <p><strong>9.2.</strong> Video ve İçerik İşleme:</p>
                    <p><strong>9.2.1.</strong> Rıza Mekanizması:</p>
                    <ul>
                      <li>Platform'a yüklenen tüm video içerikleri için ayrı ve açık rıza alınır</li>
                      <li>Rıza verilmeden video işleme yapılmaz</li>
                      <li>Üye dilediği zaman rızasını geri çekebilir</li>
                    </ul>
                    <p><strong>9.2.2.</strong> Mevcut İçerikler:</p>
                    <ul>
                      <li>Platform üzerindeki eğitim videoları Hizmet Sağlayıcı veya yetkili içerik üreticileri tarafından yüklenmiştir</li>
                      <li>İçeriklerin sorumluluğu ilgili içeriği hazırlayan kişiye aittir</li>
                    </ul>
                    <p><strong>9.2.3.</strong> İçerik Kullanım Şartları:</p>
                    <ul>
                      <li>Video içerikleri sadece Platform içinde izlenebilir</li>
                      <li>İndirme, kopyalama, dağıtma yasaktır</li>
                      <li>Ekran kaydı yapmak yasaktır</li>
                      <li>Ticari amaçla kullanılamaz</li>
                    </ul>
                    <p><strong>9.3.</strong> İçerik Silme Politikası:</p>
                    <p><strong>9.3.1.</strong> Silme Talepleri:</p>
                    <ul>
                      <li>İçerik silme talepleri yazilimkodjet@gmail.com adresinden yapılabilir</li>
                      <li>Talep sahibinin kimlik doğrulaması yapılır</li>
                      <li>Haklı nedenlere dayalı talepler değerlendirilir</li>
                    </ul>
                    <p><strong>9.3.2.</strong> Silme Süresi:</p>
                    <ul>
                      <li>Onaylanan içerikler 5 iş günü içinde sistemden kaldırılır</li>
                      <li>Yedeklerden de temizleme işlemi yapılır</li>
                      <li>İşlem tamamlandığında kullanıcıya bilgi verilir</li>
                    </ul>
                    <p><strong>9.3.3.</strong> İçerik Yedekleme:</p>
                    <ul>
                      <li>Sistem güvenliği için içerikler yedeklenir</li>
                      <li>Yedekler güvenli sunucularda şifreli saklanır</li>
                      <li>Silme talepleri yedekleri de kapsar</li>
                    </ul>
                    <p><strong>9.4.</strong> Kullanıcı Tarafından Oluşturulan İçerik:</p>
                    <ul>
                      <li>Üye, yüklediği içeriklerin yasal haklarına sahip olduğunu garanti eder</li>
                      <li>Platform, kullanıcı içeriklerini hizmet sunumu amacıyla işleyebilir</li>
                      <li>Hukuka aykırı içerikler derhal kaldırılır</li>
                    </ul>

                    <h2>MADDE 10 - SORUMLULUK SINIRLARI</h2>
                    <p><strong>10.1.</strong> Mücbir Sebepler:</p>
                    <p>Hizmet Sağlayıcı aşağıdaki mücbir sebeplerden sorumlu değildir:</p>
                    <ul>
                      <li>Doğal afetler (deprem, sel, yangın, fırtına)</li>
                      <li>Savaş, terör olayları, iç karışıklık</li>
                      <li>Salgın hastalıklar, pandemi durumları</li>
                      <li>Elektrik kesintisi, enerji altyapı arızaları</li>
                      <li>İnternet altyapı arızaları, küresel internet kesintileri</li>
                      <li>Hükümet kararları, yasaklar, yasal düzenlemeler</li>
                      <li>Siber saldırılar, DDoS ataklarından kaynaklanan kesintiler</li>
                      <li>Hizmet Sağlayıcı'nın makul kontrolü dışındaki diğer olaylar</li>
                    </ul>
                    <p><strong>10.2.</strong> Teknik Sorumluluklar:</p>
                    <p><strong>10.2.1.</strong> Bakım Çalışmaları:</p>
                    <ul>
                      <li>Planlı bakım çalışmaları mümkün olduğunca önceden duyurulur</li>
                      <li>Acil bakımlar için önceden bildirim yapılamayabilir</li>
                      <li>Bakım süresince hizmet kesintisi yaşanabilir</li>
                    </ul>
                    <p><strong>10.2.2.</strong> Veri Güvenliği:</p>
                    <ul>
                      <li>Veri kaybı riskine karşı düzenli yedekleme yapılır</li>
                      <li>Ancak %100 veri güvenliği garanti edilemez</li>
                      <li>Üye kendi önemli verilerini de yedeklemelidir</li>
                    </ul>
                    <p><strong>10.2.3.</strong> Üçüncü Taraf Servisleri:</p>
                    <ul>
                      <li>Platform, üçüncü taraf API'leri kullanabilir</li>
                      <li>Bu servislerin kesintilerinden Hizmet Sağlayıcı sorumlu değildir</li>
                    </ul>
                    <p><strong>10.3.</strong> Kullanıcı Sorumluluğu:</p>
                    <p><strong>10.3.1.</strong> Hesap Güvenliği:</p>
                    <ul>
                      <li>Hesap güvenliği kullanıcının sorumluluğundadır</li>
                      <li>Şifre paylaşımından doğan zararlar kullanıcıya aittir</li>
                      <li>Yetkisiz erişim durumunda kullanıcı derhal bildirimde bulunmalıdır</li>
                    </ul>
                    <p><strong>10.3.2.</strong> Kullanım Şekli:</p>
                    <ul>
                      <li>Platform'ın kötüye kullanımından kaynaklanan yasal sorumluluk kullanıcıya aittir</li>
                      <li>Hukuka aykırı içerik paylaşımından kullanıcı sorumludur</li>
                      <li>Telif hakkı ihlallerinden kullanıcı sorumludur</li>
                    </ul>
                    <p><strong>10.3.3.</strong> İnternet Bağlantısı:</p>
                    <ul>
                      <li>Kullanıcının internet bağlantı sorunlarından Hizmet Sağlayıcı sorumlu değildir</li>
                      <li>Cihaz uyumluluğu kullanıcının sorumluluğundadır</li>
                    </ul>
                    <p><strong>10.4.</strong> Sorumluluk Sınırı:</p>
                    <ul>
                      <li>Hizmet Sağlayıcı'nın azami sorumluluğu ödenen abonelik bedelini aşamaz</li>
                      <li>Dolaylı zararlardan, kar kaybından, veri kaybından sorumluluk kabul edilmez</li>
                      <li>Yasal zorunlu sorumluluklar saklıdır</li>
                    </ul>

                    <h2>MADDE 11 - KİŞİSEL VERİLERİN KORUNMASI</h2>
                    <p><strong>11.1.</strong> Genel İlkeler: Kişisel veriler, Platform'da yayınlanan KVKK Aydınlatma Metni'ne uygun olarak işlenir ve korunur.</p>
                    <p><strong>11.2.</strong> Açık Rıza Alımı:</p>
                    <p><strong>11.2.1.</strong> Rıza Mekanizması:</p>
                    <ul>
                      <li>Kişisel veri işleme rızası, sözleşme kabulünden AYRI bir onay kutusu ile alınır</li>
                      <li>Rıza onay kutusu işaretlenmeden üyelik tamamlanamaz</li>
                      <li>Rıza gönüllü, belirli ve bilgilendirilmiş şekilde alınır</li>
                      <li>Rıza metni açık ve anlaşılır dilde yazılmıştır</li>
                    </ul>
                    <p><strong>11.2.2.</strong> Rıza Geri Çekme:</p>
                    <ul>
                      <li>Üye dilediği zaman rızasını geri çekme hakkına sahiptir</li>
                      <li>Rıza geri çekildiğinde zorunlu haller dışında veri işleme durdurulur</li>
                      <li>Yasal zorunluluklar için gerekli veriler saklanmaya devam edilebilir</li>
                      <li>Rıza geri çekme talebi yazilimkodjet@gmail.com adresine yapılır</li>
                    </ul>
                    <p><strong>11.3.</strong> İşlenen Kişisel Veriler:</p>
                    <p><strong>11.3.1.</strong> Kimlik Bilgileri:</p>
                    <ul>
                      <li>Ad, soyad</li>
                      <li>Doğum tarihi (yaş kontrolü için)</li>
                      <li>TC kimlik numarası (talep edilirse)</li>
                    </ul>
                    <p><strong>11.3.2.</strong> İletişim Bilgileri:</p>
                    <ul>
                      <li>E-posta adresi</li>
                      <li>Telefon numarası</li>
                      <li>Adres bilgileri (fatura için)</li>
                    </ul>
                    <p><strong>11.3.3.</strong> Finansal Bilgiler:</p>
                    <ul>
                      <li>Ödeme bilgileri (kredi kartı son 4 hanesi)</li>
                      <li>Fatura bilgileri</li>
                      <li>İşlem geçmişi</li>
                    </ul>
                    <p><strong>11.3.4.</strong> Kullanım Verileri:</p>
                    <ul>
                      <li>Platform kullanım kayıtları</li>
                      <li>Giriş/çıkış logları</li>
                      <li>IP adresi</li>
                      <li>Cihaz bilgileri</li>
                      <li>Tarayıcı bilgileri</li>
                    </ul>
                    <p><strong>11.4.</strong> Veri İşleme Amaçları:</p>
                    <p>Kişisel veriler yalnızca aşağıdaki amaçlarla işlenir:</p>
                    <ul>
                      <li>Hizmet sunumu ve hesap yönetimi</li>
                      <li>İletişim ve bilgilendirme</li>
                      <li>Yasal yükümlülüklerin yerine getirilmesi</li>
                      <li>Ödeme işlemleri ve faturalama</li>
                      <li>Teknik destek sağlanması</li>
                      <li>Güvenlik ve dolandırıcılık önleme</li>
                      <li>İstatistik ve analiz (anonim veri)</li>
                    </ul>
                    <p><strong>11.5.</strong> Veri Aktarımı:</p>
                    <ul>
                      <li>Kişisel veriler üçüncü kişilerle yasal zorunluluklar dışında paylaşılmaz</li>
                      <li>Ödeme işlemleri için banka ve ödeme kuruluşlarına aktarılabilir</li>
                      <li>Yasal mercilerin talepleri KVKK'ya uygun şekilde yanıtlanır</li>
                    </ul>
                    <p><strong>11.6.</strong> Veri Güvenliği:</p>
                    <ul>
                      <li>Kişisel veriler güvenli sunucularda şifreli saklanır</li>
                      <li>SSL/TLS sertifikası kullanılır</li>
                      <li>Düzenli güvenlik testleri yapılır</li>
                      <li>Yetkisiz erişim önlenir</li>
                    </ul>
                    <p><strong>11.7.</strong> Veri Sahibi Hakları:</p>
                    <p>Üye, KVKK uyarınca aşağıdaki haklara sahiptir:</p>
                    <ul>
                      <li>Kişisel verilerinin işlenip işlenmediğini öğrenme</li>
                      <li>İşlenmişse buna ilişkin bilgi talep etme</li>
                      <li>İşlenme amacını ve amacına uygun kullanılıp kullanılmadığını öğrenme</li>
                      <li>Yurt içinde veya yurt dışında aktarıldığı üçüncü kişileri bilme</li>
                      <li>Verilerin eksik veya yanlış işlenmiş olması halinde düzeltilmesini isteme</li>
                      <li>KVKK'da öngörülen şartlar çerçevesinde silinmesini isteme</li>
                      <li>Düzeltme ve silme işlemlerinin üçüncü kişilere bildirilmesini isteme</li>
                      <li>Münhasıran otomatik sistemler ile analiz edilmesi nedeniyle aleyhine sonuç doğmasına itiraz etme</li>
                      <li>Kanuna aykırı veri işleme nedeniyle zararının giderilmesini talep etme</li>
                    </ul>
                    <p><strong>11.8.</strong> Başvuru Yöntemi:</p>
                    <ul>
                      <li>
                        Şahsen Yazılı Başvuru veya Noter aracılığıyla:
                        KIZILIRMAK MAH. UFUK ÜNİVERSİTESİ CAD. NO: 12 İÇ KAPI NO:
                        3 ÇANKAYA/ ANKARA
                      </li>
                      <li>
                        KVKK hakları için yazilimkodjet@gmail.com adresine
                        başvurulur
                      </li>
                      <li>Başvurular 30 gün içinde yanıtlanır</li>
                      <li>Yanıt için ücretsizdir (işlem maliyeti talep edilebilir)</li>
                    </ul>

                    <h2>MADDE 12 - UYUŞMAZLIKLARIN ÇÖZÜMÜ</h2>
                    <p><strong>12.1.</strong> Uygulanacak Hukuk: Bu sözleşmeden doğan uyuşmazlıklarda Türkiye Cumhuriyeti kanunları uygulanır.</p>
                    <p><strong>12.2.</strong> Yargı Yetkisi:</p>
                    <p><strong>12.2.1.</strong> Genel Yetki:</p>
                    <ul>
                      <li>Ankara Mahkemeleri ve İcra Müdürlükleri yetkilidir</li>
                    </ul>
                    <p><strong>12.2.2.</strong> Tüketici Hakları:</p>
                    <ul>
                      <li>Tüketici niteliğindeki üyeler, TKHK md.73 uyarınca kendi yerleşim yeri mahkemelerinde de dava açabilir</li>
                      <li>Tüketici hakları her halükarda saklıdır</li>
                      <li>Tüketici hakem heyetlerine başvuru hakkı mevcuttur</li>
                    </ul>
                    <p><strong>12.3.</strong> Dostane Çözüm:</p>
                    <ul>
                      <li>Uyuşmazlıklarda öncelikle dostane çözüm aranır</li>
                      <li>Taraflar müzakere yoluyla anlaşmaya çalışır</li>
                      <li>Başarısız olunması halinde yargı yoluna başvurulur</li>
                    </ul>
                    <p><strong>12.4.</strong> Tüketici Hakem Heyeti:</p>
                    <ul>
                      <li>Tüketiciler, yaşadıkları ildeki Tüketici Hakem Heyetine başvurabilir</li>
                      <li>Parasal sınırlar her yıl güncellenir</li>
                      <li>Başvuru ücretsizdir</li>
                    </ul>

                    <h2>MADDE 13 - FİYAT VE SÖZLEŞME DEĞİŞİKLİKLERİ</h2>
                    <p><strong>13.1.</strong> Fiyat Değişiklikleri:</p>
                    <p><strong>13.1.1.</strong> Değişiklik Hakkı:</p>
                    <ul>
                      <li>Hizmet Sağlayıcı, abonelik ücretlerinde değişiklik yapma hakkını saklı tutar</li>
                      <li>Ekonomik koşullar, enflasyon, vergi değişiklikleri fiyatları etkileyebilir</li>
                    </ul>
                    <p><strong>13.1.2.</strong> Mevcut Aboneliklerin Korunması:</p>
                    <ul>
                      <li>Fiyat değişiklikleri mevcut abonelikleri etkilemez</li>
                      <li>Yeni fiyatlar sadece yeni abonelikler için geçerlidir</li>
                      <li>Üyenin ödediği fiyat abonelik süresi boyunca sabittir</li>
                    </ul>
                    <p><strong>13.1.3.</strong> Bildirim:</p>
                    <ul>
                      <li>Fiyat değişiklikleri Platform'da duyurulur</li>
                      <li>Yeni üyelikler güncel fiyattan satın alınır</li>
                    </ul>
                    <p><strong>13.2.</strong> Sözleşme Değişiklikleri:</p>
                    <p><strong>13.2.1.</strong> Değişiklik Yetkisi:</p>
                    <ul>
                      <li>Bu sözleşme, Hizmet Sağlayıcı tarafından tek taraflı değiştirilebilir</li>
                      <li>Yasal zorunluluklar, hizmet geliştirmeleri değişiklik gerektirebilir</li>
                    </ul>
                    <p><strong>13.2.2.</strong> Duyuru:</p>
                    <ul>
                      <li>Değişiklikler Platform'da yayınlanır</li>
                      <li>Mümkün olduğunca üyelere e-posta ile bildirilir</li>
                      <li>Önemli değişiklikler için 15 gün önceden duyuru yapılır</li>
                    </ul>
                    <p><strong>13.2.3.</strong> Kabul:</p>
                    <ul>
                      <li>Değişiklikler yayınlandıktan sonra Platform'u kullanmaya devam etmek değişiklikleri kabul etmek anlamına gelir</li>
                      <li>Kabul etmeyen üye hesabını kapatabilir</li>
                    </ul>
                    <p><strong>13.3.</strong> Hizmet Değişiklikleri:</p>
                    <ul>
                      <li>Platform özellikleri geliştirilebilir, değiştirilebilir veya kaldırılabilir</li>
                      <li>Temel hizmet sunumu korunur</li>
                      <li>Önemli özellik değişiklikleri duyurulur</li>
                    </ul>

                    <h2>MADDE 14 - ÇEŞİTLİ HÜKÜMLER</h2>
                    <p><strong>14.1.</strong> Sözleşmenin Bütünlüğü:</p>
                    <ul>
                      <li>Bu sözleşme, taraflar arasındaki anlaşmanın tamamını oluşturur</li>
                      <li>Önceki sözlü veya yazılı anlaşmalar bu sözleşme ile hükümsüz hale gelir</li>
                    </ul>
                    <p><strong>14.2.</strong> Kısmi Geçersizlik:</p>
                    <ul>
                      <li>Sözleşme şartlarından birinin geçersiz olması diğerlerini etkilemez</li>
                      <li>Geçersiz hüküm, amacına en yakın geçerli hükümle değiştirilmiş sayılır</li>
                      <li>Sözleşmenin geri kalan kısmı yürürlükte kalır</li>
                    </ul>
                    <p><strong>14.3.</strong> Feragat:</p>
                    <ul>
                      <li>Hizmet Sağlayıcı'nın herhangi bir hakkını kullanmaması, o haktan feragat ettiği anlamına gelmez</li>
                      <li>Tek seferlik göz ardı etme, sürekli muafiyet doğurmaz</li>
                    </ul>
                    <p><strong>14.4.</strong> Bildirimlerin Geçerliliği:</p>
                    <ul>
                      <li>Tüm bildirimler e-posta yoluyla kayıtlı adrese yapılır</li>
                      <li>Bildirim gönderildiği anda tebliğ edilmiş sayılır</li>
                    </ul>
                    <p><strong>14.5.</strong> Devir:</p>
                    <ul>
                      <li>Üye, bu sözleşmeden doğan hak ve yükümlülüklerini devredemez</li>
                      <li>Hizmet Sağlayıcı, sözleşmeyi önceden bildirimde bulunarak devredebilir</li>
                    </ul>
                    <p><strong>14.6.</strong> Elektronik Ortam:</p>
                    <ul>
                      <li>Bu sözleşme elektronik ortamda kabul edilmiş olup, 6563 sayılı Elektronik Ticaret Kanunu'na tabidir</li>
                      <li>Elektronik kabul, ıslak imza ile eşdeğer sayılır</li>
                      <li>Sözleşme metni Platform üzerinden erişilebilir</li>
                    </ul>
                    <p><strong>14.7.</strong> Dil:</p>
                    <ul>
                      <li>Bu sözleşmenin geçerli dili Türkçe'dir</li>
                      <li>Çeviri varsa Türkçe metin esas alınır</li>
                    </ul>
                    <p><strong>14.8.</strong> Kayıt Tutma:</p>
                    <ul>
                      <li>Hizmet Sağlayıcı, sözleşme ve işlem kayıtlarını 10 yıl süreyle saklar</li>
                      <li>Kayıtlar delil niteliğindedir</li>
                      <li>Üye dilerse kendi kayıtlarını talep edebilir</li>
                    </ul>

                    <h2>MADDE 15 - İLETİŞİM BİLGİLERİ</h2>
                    <p><strong>Hizmet Sağlayıcı İletişim:</strong></p>
                    <ul>
                      <li><strong>Şirket:</strong> Adil Onur Karahan Şahıs Şirketi</li>
                      <li><strong>E-posta:</strong> yazilimkodjet@gmail.com</li>
                      <li><strong>Web:</strong> www.nmuniversalteam.com</li>
                    </ul>
                    <p><strong>İletişim Konuları:</strong></p>
                    <ul>
                      <li>Teknik destek talepleri</li>
                      <li>Fatura ve ödeme sorunları</li>
                      <li>İçerik silme talepleri</li>
                      <li>KVKK hakları başvuruları</li>
                      <li>Şikayet ve öneriler</li>
                      <li>Hesap kapatma talepleri</li>
                    </ul>
                    <p><strong>Yanıt Süreleri:</strong></p>
                    <ul>
                      <li>Genel talepler: 48 saat içinde</li>
                      <li>Teknik sorunlar: 24 saat içinde</li>
                      <li>KVKK başvuruları: 30 gün içinde</li>
                      <li>Acil durumlar: En kısa sürede</li>
                    </ul>

                    <h2>ÖZEL UYARILAR VE BİLGİLENDİRMELER / CAYMA HAKKI BİLGİLENDİRMESİ</h2>
                    <p><strong>ÖNEMLİ:</strong> Bu sözleşmeyi kabul etmekle:</p>
                    <ol>
                      <li><strong>Dijital İçeriğin Derhal Sunumu:</strong> Dijital hizmetin (Platform erişimi ve içeriklerinin) ödeme onayı ile birlikte DERHAL sunulacağını,</li>
                      <li><strong>Cayma Hakkından Feragat:</strong> 6502 sayılı Tüketicinin Korunması Hakkında Kanun'un 16. maddesi m bendi uyarınca cayma hakkınızdan feragat ettiğinizi,</li>
                      <li><strong>İade Şartları:</strong> Abonelik bedeli iadesinin yalnızca aşağıdaki durumlarda yapılabileceğini:
                        <ul style={{ marginTop: "10px" }}>
                          <li>Ayıplı hizmet sunumu</li>
                          <li>Hizmetin hiç ifa edilmemesi</li>
                          <li>Hizmet Sağlayıcı kusurlu durumlar</li>
                          <li>Hizmet Sağlayıcı tarafından hesap kapatılması</li>
                        </ul>
                      </li>
                    </ol>
                    <p style={{ fontWeight: "bold" }}>KABUL ETMİŞ OLURSUNUZ.</p>

                    <h2>VERİ SORUMLUSUNA BAŞVURU</h2>
                    <p>KVKK kapsamındaki haklarınızı kullanmak için:</p>
                    <ul>
                      <li><strong>E-posta:</strong> yazilimkodjet@gmail.com</li>
                      <li><strong>Konu:</strong> "KVKK Başvurusu - [Talep Türü]"</li>
                      <li>Kimlik doğrulama belgesi ekleyiniz</li>
                    </ul>

                    <h2>TÜKETİCİ BİLGİLENDİRMESİ</h2>
                    <p><strong>Tüketici Hakları:</strong></p>
                    <ul>
                      <li>Bu sözleşme bir mesafeli satış sözleşmesidir</li>
                      <li>TKHK ve ETK hükümleri uygulanır</li>
                      <li>Tüketici hakem heyetlerine başvuru hakkınız vardır</li>
                    </ul>
                    <p><strong>Şikayet Başvuru Yerleri:</strong></p>
                    <ul>
                      <li>Tüketici Hakem Heyeti (yerel)</li>
                      <li>Tüketici Mahkemesi (yerel)</li>
                      <li>yazilimkodjet@gmail.com (şirket içi çözüm)</li>
                    </ul>

                    <h2>GÜVENLİK ÖNERİLERİ</h2>
                    <p><strong>Hesap Güvenliği İçin:</strong></p>
                    <ul>
                      <li>Güçlü şifre kullanın (en az 8 karakter, büyük-küçük harf, rakam, özel karakter)</li>
                      <li>Şifrenizi kimseyle paylaşmayın</li>
                      <li>Şüpheli aktivite durumunda derhal bildirin</li>
                      <li>Düzenli olarak şifre değiştirin</li>
                      <li>Ortak cihazlarda "beni hatırla" seçeneğini kullanmayın</li>
                    </ul>
                    <p><strong>Kişisel Veri Güvenliği İçin:</strong></p>
                    <ul>
                      <li>E-posta adresinizi güncel tutun</li>
                      <li>Oltalama (phishing) e-postalarına dikkat edin</li>
                      <li>Resmi olmayan linklerden Platform'a giriş yapmayın</li>
                      <li>Kişisel bilgilerinizi üçüncü kişilerle paylaşmayın</li>
                    </ul>

                    <h2>SÖZLEŞME KABUL BEYANI</h2>
                    <p style={{ lineHeight: "1.8" }}>
                      İşbu sözleşmeyi elektronik ortamda kabul ederek:
                    </p>
                    <ul style={{ lineHeight: "1.8" }}>
                      <li>✓ Sözleşmenin tamamını okuduğumu ve anladığımı,</li>
                      <li>✓ 18 yaşını doldurduğumu veya yasal vasi onayım olduğunu,</li>
                      <li>✓ Verdiğim bilgilerin doğru ve güncel olduğunu,</li>
                      <li>✓ Dijital hizmetin derhal sunulmasını talep ettiğimi ve cayma hakkımdan feragat ettiğimi,</li>
                      <li>✓ Kişisel verilerimin KVKK Aydınlatma Metni'ne uygun işlenmesine (ayrı onay kutusu ile) rıza verdiğimi,</li>
                      <li>✓ Abonelik ücretinin {this.abonelikBedeli()} (KDV Dahil) olduğunu ve yıllık peşin ödendiğini,</li>
                      <li>✓ Otomatik yenileme olmadığını ve süre sonunda hizmetin sona ereceğini,</li>
                      <li>✓ İade şartlarını ve istisnalarını anladığımı,</li>
                      <li>✓ Platform kullanım kurallarına uymayı taahhüt ettiğimi,</li>
                    </ul>
                    <p style={{ fontWeight: "bold", fontSize: "18px", marginTop: "20px" }}>
                      BEYAN VE KABUL EDERİM.
                    </p>

                    <div style={{ textAlign: "center", marginTop: "40px", padding: "20px", backgroundColor: "#f5f5f5", borderRadius: "8px" }}>
                      <p><strong>Sözleşme Versiyonu:</strong> 2.1</p>
                      <p><strong>Son Güncelleme:</strong> 28 Nisan 2026</p>
                      <p style={{ marginTop: "20px" }}>
                        <strong>Hizmet Sağlayıcı:</strong><br />
                        Adil Onur Karahan Şahıs Şirketi
                      </p>
                    </div>

                    <div
                      style={{
                        backgroundColor: "#fff",
                        padding: "20px",
                        borderRadius: "8px",
                        border: "1px solid #ddd",
                        margin: "30px 0",
                      }}
                    >
                      <h3 style={{ marginTop: "0" }}>EK BELGELER</h3>
                      <p>Bu sözleşme ile birlikte aşağıdaki belgeler de geçerlidir:</p>
                      <ol>
                        <li>KVKK Aydınlatma Metni (Platform'da yayınlanmıştır)</li>
                        <li>Gizlilik Politikası (Platform'da yayınlanmıştır)</li>
                        <li>Kullanım Koşulları (Platform'da yayınlanmıştır)</li>
                        <li>Çerez Politikası (Platform'da yayınlanmıştır)</li>
                      </ol>
                      <p style={{ fontStyle: "italic", marginTop: "15px" }}>
                        Bu belgeler Platform üzerinden erişilebilir ve bu sözleşmenin ayrılmaz parçasıdır.
                      </p>
                    </div>

                    <div style={{ textAlign: "center", marginTop: "50px", padding: "30px", borderTop: "3px solid #333" }}>
                      <h2 style={{ marginTop: "0" }}>SÖZLEŞME SONU</h2>
                      <p style={{ fontSize: "15px", lineHeight: "1.8" }}>
                        Bu sözleşme 15 ana madde, çeşitli alt maddeler ve ek bilgilendirmelerden oluşmaktadır.
                        <br />
                        Sözleşmenin tamamı okunarak, anlaşılarak ve gönüllü olarak kabul edilmelidir.
                      </p>
                      <p style={{ marginTop: "20px", fontSize: "16px" }}>
                        <strong>Sorularınız için:</strong> yazilimkodjet@gmail.com
                      </p>
                      <p style={{ marginTop: "30px", color: "#666" }}>
                        © 2025 NM Universal Team - Tüm hakları saklıdır.
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <Footer />
      </>
    );
  }
}

export default withRouter(MembershipAgreement);